export default __webpack_public_path__ + "static/media/GrayCross.851d8fa1.svg";